import React from "react";
import Hero from "../../components/medical/Hero";
import HighlightedContactSection from "../../components/HighlightedContactSection";
import procedureImage from "../../assets/Images/service-1.png";

export default function RecruitmentProcessPage() {
  const imgSrc = typeof procedureImage === "string" ? procedureImage : procedureImage?.default ?? procedureImage;

  return (
    <>
      <Hero title="Rekrutierungsprozess" subheading="So arbeiten wir mit Ihnen zusammen." />
      <section className="bg-white pt-0 pb-16 md:pb-24">
        <div className="container-app mx-auto max-w-4xl px-4">
          <div className="overflow-hidden rounded-2xl">
            <img
              src={imgSrc}
              alt="Vorgehensweise bei der Direktansprache"
              className="h-auto w-full object-cover"
            />
          </div>
        </div>
        <HighlightedContactSection
          heading="Rekrutierungsprozess mit uns starten"
          description="Sie möchten wissen, wie wir gemeinsam vorgehen? Wir erläutern Ihnen gerne den Ablauf und die nächsten Schritte."
          buttonText="Jetzt Kontakt aufnehmen"
          sectionId="section-rekrutierungsprozess-contact"
        />
      </section>
    </>
  );
}
